import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import styles from './InfoButton.css'

import FormActions from '../../actions/FormActions'

@CSSModules(styles, { allowMultiple: true })
export default class InfoButton extends Component {
  constructor (props) {
    super(props)
    console.log(styles)
  }

  _onClick () {
    FormActions.setShowInfoMessage(true)
  }

  render () {
    return (
      <div onClick={this._onClick.bind(this)} styleName="infoButton">
        <img src={'/static/img/info.png'} styleName="image" />
        <span styleName="info">Viktig information</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/InfoButton/InfoButton.js